import { render, staticRenderFns } from "./Bukutamu.vue?vue&type=template&id=3f8d9606"
import script from "./Bukutamu.vue?vue&type=script&lang=js"
export * from "./Bukutamu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports